class HeaderDrawerMobile extends HTMLElement {
    constructor() {
        super();
        this.drawerButtons = document.querySelectorAll(`${selectorsElement.headerClass} ${selectorsElement.mobileDrawerButton}`);
        this.expandItems = this.querySelectorAll('.expand-item');
        this.setupDrawerToggle();
        this.setupExpandToggle();
        document.addEventListener('click', (event) => this.handleOutsideClick(event));
    }

    setupDrawerToggle() {
        if (!this.drawerButtons.length) return;

        this.drawerButtons.forEach((button) => {
            button.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                this.toggle(button);
            });
        });
    }

    setupExpandToggle() {
        if (!this.expandItems.length) return;

        this.expandItems.forEach((item) => {
            item.addEventListener('click', (event) => {
                event.preventDefault();
                event.stopPropagation();
                const parent = item.closest('.has-child');
                if (parent) {
                    parent.classList.toggle('active');
                }
            });
        });
    }

    toggle(button) {
        if (this.classList.contains('active')) {
            this.close(button);
        } else {
            this.open(button);
        }
    }

    removeClassModal() {
        const modalActive = document.querySelectorAll(`${selectorsElement.headerClass} ${selectorsElement.modal}`)
        const headerIconActive = document.querySelectorAll(`${selectorsElement.headerClass} ${selectorsElement.headerIconClass}`)
        modalActive.forEach((modal)=> {
            modal.classList.remove('active');
        })

        headerIconActive.forEach((icon)=>{
            icon.classList.remove('active');
        })
    }

    open(button) {
        this.removeClassModal();
        button.classList.add('active');
        this.classList.add('active');
    }

    close(button) {
        this.removeClassModal();
        button.classList.remove('active');
        this.classList.remove('active');
    }

    handleOutsideClick(event) {
        const isButtonClicked = Array.from(this.drawerButtons).some((button) => button.contains(event.target));
        if (!this.contains(event.target) && !isButtonClicked) {
            this.drawerButtons.forEach((button) => button.classList.remove('active'));
            this.classList.remove('active');
        }
    }
}

customElements.define('header-drawer-mobile', HeaderDrawerMobile);
